import '@/app/app.css';
import './product.css';

import '@/app/app';
import '@/layouts/main/main';
import {ProductImages} from '@/features/product/product-images/product-images';
import {Product} from '@/features/product/product';
import {ProductBlock} from '@/features/product-block/product-block';
import {SliderProducts} from '@/features/slider-products/slider-products';
import {ProductFixed} from '@/features/product/product-fixed/product-fixed';

window.app.ProductBlock = ProductBlock;
window.app.SliderProducts = SliderProducts;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-sticky').forEach((element) => {
		new app.Sticky(element, {
			breakpoint: vars.breakpoint.laptop,
			indentTop: 0,
			indentBottom: 20,
			top: 80,
			bottom: 20,
		});
	});

	new Product(document.querySelector('.product'));
	document.querySelectorAll('.js-product-images').forEach((element) => new ProductImages(element));
	document.querySelectorAll('.product-block').forEach((element) => new ProductBlock(element));
	document.querySelectorAll('.js-slider-products').forEach((slider) => new SliderProducts(slider));
	new ProductFixed(document.querySelector('.js-product-fixed'));
});
